<template>
  <label
    v-bind:class="['label', classname]"
  >
    {{field.label.text}}
    <strong
      v-if="field.mandatory"
      class="field--required"
    >*</strong>
  </label>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'LabelField',
  props: [
    'field',
    'classname',
  ],
};
</script>

<style lang="scss">
.label--group {
  padding-bottom: 0;
}
</style>
